module.exports = __webpack_public_path__ + "media/images/xpass/icons/globe-8d91e08a4521706e940d815507707ee2.svg";